<template>
  <div class="registration-banner">
    <div class="registration-banner__aside">
      <h2 class="registration-banner__title">
        {{ messages.bannerTitle }}
      </h2>
      <p class="registration-banner__text">
        {{ messages.bannerText }}
      </p>
      <DefButtonPrimary @click="goSingUp">
        {{ messages.bannerRegisterButton }}
      </DefButtonPrimary>
    </div>
    <div>
      <DefImg
        :result="{
          src: '/local/templates/love-you/images/front-end/repair/registration-banner.png',
        }"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import useModal from '@use/useModal/useModal';
import EnterCabinet from '@components/Cabinet/EnterCabinet/EnterCabinet.vue';
// import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';

const { messages } = defineProps(['messages']);

const modal = useModal();

const goSingUp = () => {
  modal.show(EnterCabinet, {}, { width: '440px' });
};
</script>

<script>
export default {
  name: 'RegistrationBanner',
};
</script>

<style lang="scss" scoped>
.registration-banner {
  display: grid;
  margin-bottom: 64px;
  @include point-md {
    grid-template-columns: repeat(2, 1fr);
  }
  @include point-lg {
    margin-bottom: 80px;
  }
  &__aside {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 38px 16px;
    background-color: #f7efef;
    @include point-md {
      padding: 24px;
      align-items: flex-start;
    }
    @include point-xl {
      padding: 40px 80px;
    }
    :deep {
      .def-button-primary {
        min-width: 100%;
        @include point-md {
          min-width: 276px;
        }
      }
    }
  }
  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 16px;
    @include point-md {
      font-size: 20px;
      line-height: 125%;
    }
    @include point-lg {
      font-size: 24px;
    }
  }
  &__text {
    font-weight: 500;
    font-size: 14px;
    line-height: 125%;
    margin-bottom: 24px;
    @include point-lg {
      font-size: 16px;
    }
  }
}
</style>
